<loading :active="this.allPageLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="true"
        :color="'#fff'"
        :background-color="'#000'"
        :opacity="'0.8'"
        :loader=" dots">
</loading>
<template>
  <div class="rounded-xl shadow border p-4 space-y-6 mt-6">
    <div class="text-gray-800">
      {{lang['components']['LinkAccount']['Account']['advertise_account_text']}}：{{ accountInfo.info.name }}（{{ accountInfo.info.id }}）
      <button type="button" class="text-xs text-blue-light" @click="removeAd(accountInfo.info.id, accountInfo.info.name)">{{lang['components']['LinkAccount']['Account']['adaccount_delete_button_text']}}</button>
      <button class="px-3 py-1 bg-blue-600 text-white rounded float-right" @click="audiencesSet(accountInfo.info.id)">
      受眾組合設定
      </button>
    </div>
    <div class="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
      <Card
        v-for="(item, index) in accountInfo.fanPageList"
        :key="index"
        v-model:adaccountId="accountInfo.info.id"
        v-model:id="item.id"
        v-model:title="item.title"
        v-model:imgSrc="item.imgSrc"
        v-model:checked="item.checked"
        v-bind:lang="lang"
      />
      <AddCard v-bind:lang="lang" v-model:connectId="accountInfoData.info.id" v-bind:allSelected="accountInfo.allSelected" />
    </div>

    <Dialog v-model:visible="visible" class="w-3/4 bg-white shadow rounded-xl" :modal="true">
      <loading :active="this.audiencesSetLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="true"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading>
      <template #header>
        <div class="w-full text-center text-gray-900 font-semibold">{{ accountInfo.info.name }}（{{ accountInfo.info.id }}）-受眾組合設定管理</div>
      </template>
      <div class="flex gap-6 p-4">
        <div class="w-full">
          <div class="flex flex-wrap mb-2">
            <div class="w-full flex-1 bg-white rounded-xl p-6">
              <div class="mb-4">
                <span class="text-red-500">*</span>
                <span class="text-grap-700 align-middle">受眾投遞國家</span>
              </div>
              <div class="flex flex-wrap bg-gray-50 w-full p-2 rounded-md border text-gray-600">
                <template v-for="(item, index) in selectCountriesData" :key="index">
                  <div class="flex justify-between w-full rounded m-1 p-2 text-sm bg-white border border-gray-200 cursor-pointer" @click="removeLocations(index)">
                    <span>{{ item.name }}</span>
                    <i class="pi pi-times mt-1"></i>
                  </div>
                </template>
              </div>
              <div class=" bg-white rounded-md flex items-center w-full p-2 shadow-sm border border-gray-200">
                <i class="pi pi-search"></i>
                <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  :placeholder="lang['components']['Event']['Regions']['place_input_placeholder']" v-model="searchPlace" v-on:keyup="keyup_get_country();">
              </div>
              <Listbox v-model="country" :options="locations" optionLabel="name" optionValue="key" class="w-full rounded-md" emptyMessage="Loading..." v-if="searchPlace.length > 0" />
            </div>
          </div>

          <KeywordMix ref="childKeywordMix" v-bind:editPage="cancelEdit" v-bind:targetKW="true" v-bind:targetAD="false" v-bind:viewDatalist="keywordData" v-bind:lang="showLang[selectLang]" v-bind:adaccountId="accountInfo.info.id" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" />

          <RemarketingMix ref="childRemarketingMix" v-bind:showRemarketingMix="showRemarketingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="audiencesData" v-bind:adaccountId="accountInfo.info.id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />

          <div class="flex justify-end space-x-3">
            <Button label="儲存" @click="save(accountInfo.info.id)" />
          </div>
        </div>
      </div>
      <template #footer></template>
    </Dialog>
  </div>
</template>

<script>
import Card from './Card.vue'
import AddCard from './AddCard.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import KeywordMix from '@/components/TargetEvent/KeywordMix.vue'
import AdvertisingMix from '@/components/TargetEvent/AdvertisingMix.vue'
import RemarketingMix from '@/components/TargetEvent/RemarketingMix.vue'
import Listbox from 'primevue/listbox';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import lang from '@/language/lang.json'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'Account',
  components: {
    Card,
    AddCard,
    Swal,
    Loading,
    Dialog,
    Button,
    KeywordMix,
    AdvertisingMix,
    RemarketingMix,
    Listbox,
  },
  props: {
    lang: {
      type: Object
    },
    accountInfo: {
      type: Object,
      default: () => ({
        info: {
          name: null,
          id: null,
        },
        fanPageList: [
          { id: null, title: null, imgSrc: null, checked: false}
        ],
        allSelected: false
      })
    }
  },
  data() {
    return {
      allPageLoading: false,
      audiencesSetLoading: false,
      visible: false,
      selectedIndex: null,
      keywordInput: '',
      form: {
        name: '',
        description: '',
        keywords: [],
        remarketingAudiences: [],
        lookalikeAudiences: []
      },
      savedConfigs: [
        { name: '#1', description: '第一個設定組合'},
        { name: '#2', description: '第二個設定組合'},
        { name: '#3', description: '第三個設定組合'},
      ],
      allAudiences: ['近7天訪客', '放棄購物車', '頻繁瀏覽者'],
      allLookalikeAudiences: ['類似購買者', '類似活躍用戶'],
      cancelEdit: false,
      selectLang: 'zh-TW',
      showLang: lang,
      keywordData: {
        product_url:null,
        keywords:null,
        base_keyword_list: [],
        select_keywords:null
      },
      audiencesData: {
        default_audiences:null,
        custom_audiences:null,
        custom_audiences_selected:null,
        default_audiences_list:null,
        custom_audiences_list:null
      },
      keywordUrl: null,
      productUrl: null,
      youtubeClose: false,
      updateId: null,
      country: null,
      searchPlace: '',
      locations: [],
      locations_mark: [],
      selectCountriesData: [],
    };
  },
  watch:{
    'visible': function(value){
      if(value == false){
        this.productUrl = null;

        this.keywordData = {
          product_url:null,
          keywords:null,
          base_keyword_list: [],
          select_keywords:null
        };
        this.audiencesData = {
          default_audiences:null,
          custom_audiences:null,
          custom_audiences_selected:null,
          default_audiences_list:null,
          custom_audiences_list:null
        };
      }
    },
    country(v) {
      // console.log('country');
      // console.log(v);

      var inArray = 0

      for (let i = 0; i < this.selectCountriesData.length; i++) {
        if (this.selectCountriesData[i].key === v) {
          inArray = 1
        }
      }

      if(inArray == 0 && v != null){
        this.selectCountriesData.push(this.locations_mark[v])
      }

      // this.$emit('update:selectCountries', this.selectCountriesData)
      this.searchPlace = ''

      // console.log(this.selectCountriesData);
    },
  },
  methods: {
    removeAd(id, name){
      console.log('removeAd');
      // console.log('id');
      // console.log(id);
      // console.log('name');
      // console.log(name);

      let member_hash = this.$route.params.id

      axios
        .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'member',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  // window.location.href = "https://dev-private.autoturn.net/"+member_hash;
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.$emit('childConnectAccount', 'true_'+todayForm);
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  // window.location.href = "https://dev-private.autoturn.net/"+member_hash;
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.$emit('childConnectAccount', 'true_'+todayForm);
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                // if (result.isConfirmed) {
                //   // Swal.fire('Saved!', '', 'success')
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // } else if (result.isDenied) {
                //   // Swal.fire('Changes are not saved', '', 'info')
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // }

                // if (result.dismiss === Swal.DismissReason.timer) {
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // }
              })
            } else {
              Swal.fire(
                        this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire({
                  title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_title_b'],
                  html: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_html_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_html_b']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_html_c'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['yes_button'],
                  cancelButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    axios
                      .post('https://test.autoturn.net/inside/api/data/fan_adaccount_remove_ad.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: id
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        // if(response.data.status == 'success'){
                          // Swal.fire(
                          //   "刪除「"+name+"」廣告帳戶連結",
                          //   response.data.info,
                          //   response.data.status
                          // )
                          Swal.fire({
                            icon: response.data.status,
                            title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['fan_adaccount_remove_ad']['swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['fan_adaccount_remove_ad']['swal_title_b'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')
                              // this.allPageLoading = true;
                              // window.location.reload();
                              var todayForm = new Date();
                              var yearForm = todayForm.getFullYear();
                              var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              todayForm = yearForm + monthForm + dateForm + timeForm;

                              this.$emit('childConnectAccount', 'true_'+todayForm);
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                              // this.allPageLoading = true;
                              // window.location.reload();
                              var todayForm = new Date();
                              var yearForm = todayForm.getFullYear();
                              var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              todayForm = yearForm + monthForm + dateForm + timeForm;

                              this.$emit('childConnectAccount', 'true_'+todayForm);
                            }
                          })
                        // }
                      });
                  }
                })
              }
            });
          }

          if(caResponse.data.status == 'success'){
            Swal.fire({
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_title_b'],
              html: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_html_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_html_b']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_html_c'],
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['yes_button'],
              cancelButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['no_button'],
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .post('https://test.autoturn.net/inside/api/data/fan_adaccount_remove_ad.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: id
                  }))
                  .then((response) => {
                    // console.log(response.data);
                    // if(response.data.status == 'success'){
                      // Swal.fire(
                      //   "刪除「"+name+"」廣告帳戶連結",
                      //   response.data.info,
                      //   response.data.status
                      // )
                      Swal.fire({
                        icon: response.data.status,
                        title: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['fan_adaccount_remove_ad']['swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['fan_adaccount_remove_ad']['swal_title_b'],
                        text: response.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['fan_adaccount_remove_ad']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          // this.allPageLoading = true;
                          // window.location.reload();
                          var todayForm = new Date();
                          var yearForm = todayForm.getFullYear();
                          var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          todayForm = yearForm + monthForm + dateForm + timeForm;

                          this.$emit('childConnectAccount', 'true_'+todayForm);
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          // this.allPageLoading = true;
                          // window.location.reload();
                          var todayForm = new Date();
                          var yearForm = todayForm.getFullYear();
                          var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          todayForm = yearForm + monthForm + dateForm + timeForm;

                          this.$emit('childConnectAccount', 'true_'+todayForm);
                        }
                      })
                    // }
                  });
              }
            })
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_title'],
              text: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    openNewDialog() {
      this.visible = true;
      this.newConfig();
    },
    addKeyword() {
      const kw = this.keywordInput.trim();
      if (kw && !this.form.keywords.includes(kw)) {
        this.form.keywords.push(kw);
      }
      this.keywordInput = '';
    },
    save(value) {
      console.log('save');
      console.log('adaccountId', value);
      console.log('this.keywordData', this.keywordData);
      console.log('this.audiencesData', this.audiencesData);

      this.audiencesSetLoading = true;

      let selectCountriesLength = this.selectCountriesData.length;

      let keywordsData = this.keywordData.select_keywords;
      let keywordsSelected = 0;
      for (let i = 0; i < keywordsData.length; i++) {
        if (keywordsData[i].checked == true) {
          keywordsSelected = parseInt(keywordsSelected) + parseInt(1);
        }
      }
      let defaultAudiencesData = this.audiencesData.default_audiences_list;
      let defaultAudiencesSelected = 0;
      for (let i = 0; i < defaultAudiencesData.length; i++) {
        if (defaultAudiencesData[i].checked == true) {
          defaultAudiencesSelected = parseInt(defaultAudiencesSelected) + parseInt(1);
        }
      }
      let customAudiencesSelected = this.audiencesData.custom_audiences_selected;
      let audiencesSelected = parseInt(defaultAudiencesSelected) + parseInt(customAudiencesSelected.length);
      let isTrue = 1;
      let swalTitle = "";
      let swalText = "";

      if(audiencesSelected < 2){
        isTrue = 0;
        swalTitle = "受眾設定組合管理";
        swalText = "再行銷至少選擇 2 個受眾資料。";
      }

      if(keywordsSelected < 5){
        isTrue = 0;
        swalTitle = "受眾設定組合管理";
        swalText = "精準興趣須選滿 5 個關鍵字。";
      }

      if(keywordsSelected > 5){
        isTrue = 0;
        swalTitle = "受眾設定組合管理";
        swalText = "精準興趣最多只能選滿 5 個關鍵字。";
      }

      if(selectCountriesLength <= 0){
        isTrue = 0;
        swalTitle = "受眾設定組合管理";
        swalText = "請至少選擇一個受眾投遞國家。";
      }

      if(isTrue == 1){
        let member_hash = this.$route.params.id
        let formData = {
          id: this.updateId,
          adaccount_id: value,
          selectCountriesData: this.selectCountriesData,
          keywordData: this.keywordData,
          audiencesData: this.audiencesData
        }

        axios
          .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: this.$route.params.type,
            active: 'member',
          }))
          .then((caResponse) => {

            if(caResponse.data.status == 'error'){
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    // window.location.href = "https://dev-private.autoturn.net/"+member_hash;
                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    todayForm = yearForm + monthForm + dateForm + timeForm;

                    this.$emit('childConnectAccount', 'true_'+todayForm);
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    // window.location.href = "https://dev-private.autoturn.net/"+member_hash;
                    var todayForm = new Date();
                    var yearForm = todayForm.getFullYear();
                    var dateForm = String(todayForm.getDate()).padStart(2, '0');
                    var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                    todayForm = yearForm + monthForm + dateForm + timeForm;

                    this.$emit('childConnectAccount', 'true_'+todayForm);
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if (result.isConfirmed) {
                  //   // Swal.fire('Saved!', '', 'success')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // } else if (result.isDenied) {
                  //   // Swal.fire('Changes are not saved', '', 'info')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }

                  // if (result.dismiss === Swal.DismissReason.timer) {
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }
                })
              } else {
                Swal.fire(
                          this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning'){
              Swal.fire({
                icon: 'warning',
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .post('https://test.autoturn.net/inside/api/target/data/adaccount_audiences_update.php', Qs.stringify({
                      s_code: member_hash,
                      form_data: formData
                    }))
                    .then((response) => {
                      console.log('warning response', response);
                    });
                }
              });
            }

            if(caResponse.data.status == 'success'){
              axios
                .post('https://test.autoturn.net/inside/api/target/data/adaccount_audiences_update.php', Qs.stringify({
                  s_code: member_hash,
                  form_data: formData
                }))
                .then((response) => {
                  console.log('success response', response);
                  // console.log('response.data.return', response.data.return_data);
                  // console.log('response.data.return.custom_audiences_list', response.data.return_data.custom_audiences_list);

                  if(response.data.status == 'success'){
                    // Swal.fire(
                    //   "受眾設定組合管理",
                    //   "更新完成。",
                    //   "success"
                    // );

                    Swal.fire({
                      icon: 'success',
                      title: "受眾設定組合管理",
                      text: "更新完成。",
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: "OK",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.visible = false;
                      } else if (result.isDenied) {
                        this.visible = false;
                      }

                      if (result.dismiss === Swal.DismissReason.timer) {
                        this.visible = false;
                      }
                    })
                  } else {
                    Swal.fire(
                      "受眾設定組合管理",
                      "更新失敗，請稍候再嘗試",
                      "error"
                    );
                  }

                  this.audiencesSetLoading = false;
                });
            }

            if(caResponse.data.status == 'login'){
              this.audiencesSetLoading = false;

              Swal.fire({
                icon: 'error',
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_title'],
                text: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });
      } else {
        Swal.fire(
          swalTitle,
          swalText,
          "error"
        );

        this.audiencesSetLoading = false;

        return false;
      }
    },
    resetForm() {
      this.form = {
        name: '',
        description: '',
        keywords: [],
        remarketingAudiences: [],
        lookalikeAudiences: []
      };
    },
    audiencesSet(value){
      this.audiencesSetLoading = true;
      this.visible = true;

      let member_hash = this.$route.params.id
      let adaccountId = value

      axios
        .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'member',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  // window.location.href = "https://dev-private.autoturn.net/"+member_hash;
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.$emit('childConnectAccount', 'true_'+todayForm);
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  // window.location.href = "https://dev-private.autoturn.net/"+member_hash;
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.$emit('childConnectAccount', 'true_'+todayForm);
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                // if (result.isConfirmed) {
                //   // Swal.fire('Saved!', '', 'success')
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // } else if (result.isDenied) {
                //   // Swal.fire('Changes are not saved', '', 'info')
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // }

                // if (result.dismiss === Swal.DismissReason.timer) {
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // }
              })
            } else {
              Swal.fire(
                        this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .post('https://test.autoturn.net/inside/api/target/campaign/adaccount_audiences.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: adaccountId
                  }))
                  .then((response) => {
                    console.log('success response', response);
                    console.log('response.data.return', response.data.return_data);
                    console.log('response.data.return.custom_audiences_list', response.data.return_data.custom_audiences_list);

                    if(response.data.status == 'success'){
                      this.selectCountriesData = response.data.return_data.countries;

                      console.log('this.selectCountriesData', this.selectCountriesData);

                      this.keywordData = {
                                            product_url : response.data.return_data.product_url,
                                            keywords : response.data.return_data.keywords,
                                            base_keyword_list: response.data.return_data.base_keyword_list,
                                            select_keywords : response.data.return_data.keywords
                                          }

                      console.log('this.keywordData');
                      console.log(this.keywordData);

                      this.lookData = {
                                        default_lookalikes : response.data.return_data.default_lookalikes,
                                        custom_lookalikes : response.data.return_data.custom_lookalikes,
                                        custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                        default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                        custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                      }

                      console.log('this.lookData');
                      console.log(this.lookData);

                      this.audiencesData = {
                                        default_audiences : response.data.return_data.default_audiences,
                                        custom_audiences : response.data.return_data.custom_audiences,
                                        custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                        default_audiences_list : response.data.return_data.default_audiences_list,
                                        custom_audiences_list : response.data.return_data.custom_audiences_list
                                      }
                    }

                    this.audiencesSetLoading = false;
                  });
              }
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post('https://test.autoturn.net/inside/api/target/campaign/adaccount_audiences.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: adaccountId
              }))
              .then((response) => {
                console.log('success response', response);
                console.log('response.data.return', response.data.return_data);
                console.log('response.data.return.custom_audiences_list', response.data.return_data.custom_audiences_list);

                if(response.data.status == 'success'){
                  this.updateId = response.data.return_data.id;

                  this.selectCountriesData = response.data.return_data.countries;

                  console.log('this.selectCountriesData', this.selectCountriesData);
                      
                  this.keywordData = {
                                        product_url : response.data.return_data.product_url,
                                        keywords : response.data.return_data.keywords,
                                        base_keyword_list: response.data.return_data.base_keyword_list,
                                        select_keywords : response.data.return_data.keywords
                                      }

                  console.log('this.keywordData');
                  console.log(this.keywordData);

                  this.lookData = {
                                    default_lookalikes : response.data.return_data.default_lookalikes,
                                    custom_lookalikes : response.data.return_data.custom_lookalikes,
                                    custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                    default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                    custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                  }

                  console.log('this.lookData');
                  console.log(this.lookData);

                  this.audiencesData = {
                                    default_audiences : response.data.return_data.default_audiences,
                                    custom_audiences : response.data.return_data.custom_audiences,
                                    custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                    default_audiences_list : response.data.return_data.default_audiences_list,
                                    custom_audiences_list : response.data.return_data.custom_audiences_list
                                  }
                }

                this.audiencesSetLoading = false;
              });
          }

          if(caResponse.data.status == 'login'){
            this.audiencesSetLoading = false;

            Swal.fire({
              icon: 'error',
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_title'],
              text: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    keyup_get_country(){
      // console.log('searchPlace');
      // console.log(this.searchPlace);
      // console.log('selectCountriesData');
      // console.log(this.selectCountriesData);
      // console.log('country');
      // console.log(this.country);
      console.log('keyup_get_country', this.searchPlace);

      this.country = null
      this.locations = []

      axios
      .post('https://test.autoturn.net/inside/api/target/campaign/campaign_form_target_locations_search.php', Qs.stringify({
        s_code: this.$route.params.id,
        q: this.searchPlace
      }))
      .then((response) => {
        console.log('campaign_form_target_locations_search', response);
        if(response.data.status == 'success'){
          this.locations = response.data.return_data
          this.locations_mark = response.data.return_data_mark
        }
      });

    },
    removeLocations(index) {
      // console.log('remove');
      // console.log(index);
      this.selectCountriesData.splice(index, 1);

      // this.$emit('update:selectCountries', this.selectCountriesData)
    },
  },
  computed: {
    accountInfoData: {
      get: function () {
        return this.accountInfo
      },
      set: function (value) {
        this.$emit('update:accountInfoData', value)
      },
    }
  }
}
</script>

<style scoped>

</style>